import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { EReprocessService } from '../../components/conversation-data/components/reprocessing-tools/reprocessing-tools.component';
import { HttpErrorResponse } from '@angular/common/http';

export const REPROCESS_API_ACTIONS = createActionGroup({
  source: 'Reprocess API',
  events: {
    reprocess: props<{ data: EReprocessService[] }>(),
    error: props<{ error: HttpErrorResponse }>(),
    success: emptyProps(),
  },
});
